// this file added by Bearer Web Developer
export enum ApiIntegrationEnum {
    EnableApiIntegration = 'EnableApiIntegration',
    GenerateApiIntegration = 'GenerateApiIntegration',
    RegenerateApiIntegration = 'RegenerateApiIntegration',
    AfterRegenerateApiIntegration = 'AfterRegenerateApiIntegration',
}